<template>
  <div>
    <c-title>Bewertungen zu Ihrem Förderprogramm</c-title>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <div v-else>
      <p v-if="xLabels.length === 0">Noch keine Bewertungen vorhanden.</p>
      <div v-else>
        <c-process-rating-chart
          :colors="colors"
          :ratings="ratings"
          :x-labels="xLabels"
          :y-labels="['1', '2', '3', '4', '5']"
          :process="process"
        />
        <c-process-rating-list
          v-if="process"
          :process="process"
          :ratings="ratings"
        />
      </div>
    </div>

  </div>
</template>

<script>
import CTitle from '@/components/CTitle'
import CBusy from '@/components/CBusy'
import CCard from '@/components/CCard'
import CRating from '@/components/CRating'
import CProcessRatingChart from '@/components/process/CProcessRatingChart'
import CProcessRatingList from '@/components/process/CProcessRatingList'

export default {
  name: 'VProcessRatingList',

  components: {
    CBusy,
    CTitle,
    CCard,
    CRating,
    CProcessRatingChart,
    CProcessRatingList
  },

  props: {
    identifier: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      process: null,
      message: '',
      ratings: {},
      xLabels: [],
      colors: {
        user: '#53ae44',
        reviewer: '#24246c'
      }
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('workflow/process/' + this.identifier + '/')
      .then(response => {
        this.process = response.data
        if (this.process.workflow.enable_rating === false) {
          this.$store.commit('notifications/add', {
            text: 'Für das gewählte Förderprogramm sind keine Bewertungen zulässig.',
            type: 'error'
          })
          this.$router.push({ name: 'dashboard' })
        }
        return this.$api.get('workflow/rating/' + this.identifier + '/fetch/')
      })
      .then(response => {
        this.ratings = response.data
        this.xLabels = this.ratings['periods']
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(() => {
        this.$store.commit('notifications/add', {
          text: 'Ungültiges Förderprogramm',
          type: 'error'
        })
        this.loadStatus = this.$config.status.ERROR
      })
  }
}
</script>
